<template>
  <div class="w-100 d-flex flex-column" style="gap: 56px;">
    <div class="my-fees d-flex flex-column" style="gap: 24px;">
      <div class="title">
        <h5>{{ $t("views.seller.my_account.text_1245") }}</h5>
        <p>{{ $t("views.seller.my_account.text_1247") }}</p>
      </div>
      <div class="my-fees-table d-flex flex-column">
        <div class="my-fees-table-header d-flex align-items-center">
          <p>{{ $t("views.seller.my_account.text_1260") }}</p>
        </div>
        <div class="my-fees-table-body d-flex align-items-center flex-column">
          <div v-for="(fee, key) in fees" :key="key" class="my-fees-table-row d-flex w-100 justify-content-between">
            <div class="my-fees-table-cell d-flex">
              <p>{{ $t('views.seller.sales.' + fee.label) }}</p>
            </div>
            <div class="my-fees-table-cell d-flex" style="min-width: 100px;">
              <p class="bold">{{ fee.value }}</p>
            </div>
          </div>
        </div>
        <div v-if="internationalFees.length" class="my-fees-table-footer d-flex align-items-center">
          <p>{{ $t("views.seller.my_account.text_1261") }}</p>
        </div>
        <div class="my-fees-table-body d-flex align-items-center flex-column">
          <div v-for="(fee, key) in internationalFees" :key="key" class="my-fees-table-row d-flex w-100 justify-content-between">
            <div class="my-fees-table-cell d-flex">
              <p>{{ $t('views.seller.sales.' + fee.label) }}</p>
            </div>
            <div class="my-fees-table-cell d-flex">
              <p class="bold">{{ fee.value }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="indicateds d-flex flex-column" style="gap: 12px;">
      <div class="d-flex align-items-center justify-content-between">
        <b-col cols="12" md="6" class="p-0">
          <div class="title">
            <h5>{{ $t("views.seller.my_account.text_1252") }}</h5>
          </div>
        </b-col>
        <b-col cols="12" md="6" class="p-0">
          <div class="input-search-container">
            <img src="@/assets/img/icons/u_search-primary.svg" class="search-icon" />
            <b-form-input type="text" :placeholder="$t('views.seller.sales.text_1356')" v-on:input="debounce"
              v-model="search" class="input-search bg-white" />
          </div>
        </b-col>
      </div>
      <b-table :fields="fields" :items="items" outlined class="custom-table">
        <template #cell(seller)="data">
          <p class="text-bold">{{ data.item.seller }}</p>
          <p class="text-normal">{{ data.item.email }}</p>
          <p class="text-normal">{{ data.item.phone }}</p>
        </template>
        <template #cell(comission)="data">
          <div>
            <b-button variant="white" :id="`popover-button-variant-${data.item.id}`" tabindex="0">
              <img src="@/assets/img/icons/eye.svg" alt="Detalhes" />
            </b-button>
            <b-popover :target="`popover-button-variant-${data.item.id}`" placement="bottom" triggers="focus">
              <Comission :indicated="data.item"></Comission>
            </b-popover>
          </div>
        </template>
      </b-table>
    </div>
    <p class="note-support">
      {{ $t('views.seller.my_account.text_1342') }},
      <a target="_blank" href="https://faq.voompcreators.com.br/">{{ $t('views.seller.my_account.text_1237')
        }}</a>
    </p>
  </div>
</template>

<script>
import moment from 'moment';
import Money from '@/mixins/money'

import AmbassadorService from '@/services/resources/AmbassadorService';
import UserService from '@/services/resources/UserService';

import Comission from './Comission.vue';

const ambassadorService = AmbassadorService.build();
const userService = UserService.build();

export default {
  name: 'MyFeesTab',
  mixins: [Money],
  components: {
    Comission
  },
  props: {
  },
  data() {
    return {
      search: null,
      fees: [],
      internationalFees: [],
      fields: [
        { key: 'seller', label: this.$t("views.seller.my_account.text_1248") },
        { key: 'dateStart', label: this.$t("views.seller.my_account.text_1249") },
        { key: 'dateEnd', label: this.$t("views.seller.my_account.text_1250") },
        { key: 'comission', label: this.$t("views.seller.my_account.text_1251") },
      ],
      items: [],
      labelFees: {
        boleto: 'text_1393',
        credit_card: 'text_1394',
        international_credit_card: 'text_1395',
        paypal: 'text_1396',
        pix: 'text_1397'
      }
    }
  },
  computed: {
    userId() {
      return this.$store.getters.getProfile.id;
    }
  },
  methods: {
    formatNumber(value, format) {
      if (format === 'percent') {
        return `${this.formatMoney(value)}%`;
      }
      return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
      }).format(value);
    },
    async fetchSellerFees() {
      try {
        const { fees } = await userService.search({ url: '/fees' });

        if (!fees) {
          return;
        }

        for (const key in fees) {
          if (!this.labelFees[key]) {
            continue;
          }
          if (key.includes('international')) {
            this.internationalFees.push({ 
              label: this.labelFees[key], 
              value: this.formatNumber(fees[key].value, fees[key].format_type)
            });
          } else {
            this.fees.push({ 
              label: this.labelFees[key], 
              value: this.formatNumber(fees[key].value, fees[key].format_type)
            });
          }
        }
      } catch (error) {
        this.sellerFee = null;
      }
    },
    async fetchIndicatedAmbassador(search = null) {
      const data = {
        url: '/indicateds/' + this.userId,
        per_page: 10,
        page: 1,
        order_by: 'created_at',
        order_type: 'DESC',
      };

      if (search !== null) {
        data.search = search;
      }

      const { indicateds } = await ambassadorService
        .search(data)

      if (!indicateds.length) {
        this.items = [];
        return;
      }

      indicateds.forEach(({ name, email, cellphone, created_at, ended_at, comission, ...rest }) => {
        const newItems = [];
        newItems.push({
          id: Math.random(),
          seller: name,
          email,
          phone: cellphone,
          dateStart: moment(created_at).format('DD/MM/YYYY'),
          dateEnd: moment(ended_at).format('DD/MM/YYYY'),
          comission,
          ...rest
        });
        this.items = newItems;
      });
    },
    debounce: _.debounce(function () {
      this.fetchIndicatedAmbassador(this.search);
    }, 500)
  },
  mounted() {
    if (this.userId) {
      this.fetchIndicatedAmbassador();
    }
    this.fetchSellerFees();
  }

};
</script>

<style>
.indicateds .title {
  padding: 8px 12px;
}

.indicateds .input-search {
  height: inherit !important;
  padding: 10px 42px !important;
  border-radius: 4px !important;
  border: 1px solid var(--Default-gray-200, #E5E7EB) !important;
}

.indicateds .input-search-icon {
  position: relative;
  width: 16px;
  height: 16px;
}

.indicateds .search-icon {
  position: absolute;
  left: 16px;
  bottom: 13px;
}

.custom-table {
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  border: 1px solid var(--Default-gray-200, #E5E7EB);
  ;
}

.custom-table thead {
  background: var(--Default-gray-100, #F3F4F6);
}

.custom-table thead th {
  border-bottom: 1px solid var(--Default-gray-200, #E5E7EB);
  padding: 12px 24px;
}

.custom-table thead tr th div {
  color: var(--Default-gray-600, #4B5563);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

.custom-table th,
.custom-table td {
  padding: 8px;
  border-top: none !important;
  border-bottom: 1px solid var(--Default-gray-200, #E5E7EB);
}

.custom-table tr:last-child td {
  border-bottom: none;
}

.custom-table tbody td {
  padding: 18px 24px;
  vertical-align: middle;
  color: var(--Default-gray-500, #6B7280);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.custom-table tbody .text-normal {
  font-style: normal;
  font-weight: 400;
}

.custom-table tbody .text-bold {
  color: var(--Default-gray-900, #111827) !important;
  font-weight: 600;
  display: block;
}

.custom-table tbody tr {
  height: 96px;
}

.popover {
  max-width: 737px !important;
  width: 737px !important;
}

.my-fees-table {
  border-radius: 8px;
  border: 1px solid var(--Default-gray-200, #E5E7EB);
  background: var(--Default-white, #FFF);

}

.my-fees-table-header {
  height: 44px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 12px 24px;
  border-bottom: 1px solid var(--Default-gray-200, #E5E7EB);
  background: var(--Default-gray-100, #F3F4F6);
}

.my-fees-table-header p {
  color: var(--Default-gray-900, #111827) !important;
  font-weight: 600;
}

.my-fees-table-body .my-fees-table-row {
  border-bottom: 1px solid var(--Default-gray-200, #E5E7EB);
}

.my-fees-table-body .my-fees-table-row:last-child {
  border-bottom: none;
}

.my-fees-table-cell {
  display: flex;
  padding: 18px 24px;
  align-items: center;
  align-self: stretch;
}

.my-fees-table-footer {
  height: 44px;
  padding: 12px 24px;
  border-top: 1px solid var(--Default-gray-200, #E5E7EB);
  border-bottom: 1px solid var(--Default-gray-200, #E5E7EB);
  background: var(--Default-gray-100, #F3F4F6);
}

.my-fees-table-footer p {
  color: var(--Default-gray-900, #111827) !important;
  font-weight: 600;
}

.note-support a {
  color: var(--Default-primary-800, #0854C5);
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
</style>
